export default __webpack_public_path__ + "static/media/IndoNepalLogo.364a77f8.jpeg";